
<div class="viewsRatingStars">
  <span
    v-for="star in stars"
    :key="star"
    class="star"
    :style="getStarStyle(star)"
  >★</span>
  <span class="viewsRatingStars__rating">{{ rating > 0 ? rating.toFixed(1) : '-' }}</span>
</div>
